function dm_c14() {

    $('.expand-all').each(function () {

        const $toggle = $(this);
        const expand_text = $toggle.data('expand') || 'Expand all';
        const collapse_text = $toggle.data('collapse') || 'Collapse all';
        const $accordion = $toggle.closest('.container-fluid').find('.accordion');
        const $items = $accordion.find('.accordion-item');
        const $buttons = $items.find('.accordion-button');

        function panels() {
            return $items.find('.accordion-collapse');
        }

        function setButtonState($panel, isOpen) {
            const $btn = $panel.prev('.accordion-header').find('.accordion-button');
            if (isOpen) $btn.removeClass('collapsed').attr('aria-expanded', 'true');
            else $btn.addClass('collapsed').attr('aria-expanded', 'false');
        }

        function openPanel($panel) {
            if ($panel.hasClass('show')) return;
            $panel.removeClass('collapse').addClass('collapsing').height(0);
            const fullHeight = $panel.prop('scrollHeight');
            $panel.height(fullHeight);
            $panel.one('transitionend', function () {
                $panel.removeClass('collapsing').addClass('collapse show').height('');
                updateToggleText();
            });
            setButtonState($panel, true);
        }

        function closePanel($panel) {
            if (!$panel.hasClass('show')) return;
            const fullHeight = $panel.prop('scrollHeight');
            $panel.height(fullHeight);
            $panel[0].offsetHeight;
            $panel.removeClass('collapse show').addClass('collapsing').height(0);
            $panel.one('transitionend', function () {
                $panel.removeClass('collapsing').addClass('collapse').height('');
                updateToggleText();
            });
            setButtonState($panel, false);
        }

        function updateToggleText() {
            const $allPanels = panels();
            const opened = $allPanels.filter('.show').length;
            const total = $allPanels.length;
            if (opened === total && total > 0) $toggle.text(collapse_text);
            else $toggle.text(expand_text);
        }

        $buttons.off('click.dmC14').on('click.dmC14', function (e) {
            e.preventDefault();
            const $btn = $(this);
            const $panel = $btn.closest('.accordion-item').find('.accordion-collapse');
            if ($panel.hasClass('show')) closePanel($panel);
            else openPanel($panel);
        });

        $toggle.off('click.dmAll').on('click.dmAll', function () {
            const $allPanels = panels();
            const expandMode = $toggle.text().trim() === expand_text;
            if (expandMode) $allPanels.each(function () { openPanel($(this)); });
            else $allPanels.each(function () { closePanel($(this)); });
            $toggle.text(expandMode ? collapse_text : expand_text);
        });

        panels().each(function () {
            const $p = $(this);
            $p.off('transitionend.dmC14init').on('transitionend.dmC14init', function () {
                updateToggleText();
            });
        });

        updateToggleText();
    });
}

export { dm_c14 };
